import React, { useEffect, useState } from "react";
import "../../styles/ITServicesComponent.css";
import { itServicesData } from "../../../data/services";

const ITServices = () => {
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  // Rotate image every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveImageIndex((prevIndex) =>
        prevIndex === itServicesData.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="container">
      <div className="layout">
        <div className="content">
          <h1>
           <span style={{ fontSize: '35px' }}>ITマネージドサービス、システム開発でお困り事はございませんか？</span>
          </h1>
          <p>
            当社は、お客様のビジネス目標にシームレスに適合するようカスタマイズされた技術ソリューションを展開します。
          </p>

          <div className="accordion">
            {itServicesData.map((item) => (
              <div key={item.id} className="accordion-item">
                <div className="header">
                  <h3 style={{ color: "black", fontWeight: "bold" }}>
                    {item.title}
                  </h3>
                </div>
                <p className="expanded-content">{item.content}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="image-container">
          <img
            src={
              itServicesData[activeImageIndex]?.img ||
              "/assets/images/betteritservice/Comprehensive IT Services 1.webp"
            }
            alt="IT Services"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/assets/images/betteritservice/Comprehensive IT Services 1.webp";
            }}
          />

        </div>
      </div>
    </div>
  );
};

export default ITServices;